import i18nCountries from 'i18n-iso-countries';
import enLocale from 'i18n-iso-countries/langs/en.json';
import { type CountryCode, getCountries, getCountryCallingCode, isSupportedCountry } from 'libphonenumber-js';

i18nCountries.registerLocale(enLocale);

import type { SupportedCountry } from './types';

function computeSupportedCountries() {
  const countryCodes = getCountries().filter((countryCode) => isSupportedCountry(countryCode));

  const countries = countryCodes
    .map((code) => {
      return {
        code,
        name: i18nCountries.getName(code, 'en'),
        countryCallingCode: getCountryCallingCode(code),
      };
    })
    .filter((item) => item.name)
    .sort((a, b) => {
      return a.name?.localeCompare(b.name as string) ?? 0;
    });

  return countries as SupportedCountry[];
}

export const SUPPORTED_COUNTRIES: SupportedCountry[] = computeSupportedCountries();

export const COUNTRY_ALIASES: Partial<Record<CountryCode, string[]>> = {
  US: ['America', 'USA'],
  AE: ['UAE'],
} as const;
